import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import {
  getCustomApiSyncJobs,
  setCustomApiSyncJobInvisible,
  fetchCustomApiSyncJobStatus
} from 'src/reducers/employees/employeeAttendances';
import { Close } from 'jbc-front/components/icons';
import { JobFailed, JobInprogress, JobSuccess } from 'src/components/JobStatus';
import styles from './CustomApiSyncJobsStatus.scss';

const TaskResult = ({ tasks, status, hideSyncJobNotifications }) => {
  const { t } = useTranslation();
  let statusText = t('features.EmployeeAttendances.components.CustomApiSyncJobsStatus.Acquired_attendance_data');
  let tasksStyle = styles.tasksSuccess;

  if (status === 'failed') {
    statusText = t('features.EmployeeAttendances.components.CustomApiSyncJobsStatus.Cannot_acquire_attendance_data');
    tasksStyle = styles.tasksFailed;
  } else if (status === 'inProgress') {
    statusText = t('features.EmployeeAttendances.components.CustomApiSyncJobsStatus.Acquiring_attendance_data');
    tasksStyle = styles.tasksInprogress;
  }

  return (
    <React.Fragment>
      {!isEmpty(tasks) &&
        tasks.length > 0 && (
          <div className={tasksStyle}>
            <div className={styles.inner}>
              {status === 'success' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideSyncJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => (
                      <JobSuccess
                        key={task.id}
                        statusText={statusText}
                        jobInfo={''}
                        startAt={task.executeAt}
                        endAt={task.executeDoneAt}
                        canNotSyncEmployees={task.canNotSyncEmployees}
                      />
                    ))}
                  </ul>
                </React.Fragment>
              )}
              {status === 'failed' && (
                <React.Fragment>
                  <div className={styles.close} role="presentation" onClick={() => hideSyncJobNotifications(tasks)}>
                    <Close size={20} />
                  </div>
                  <ul className={styles.list}>
                    {tasks.map(task => (
                      <JobFailed
                        key={task.id}
                        statusText={statusText}
                        jobInfo={''}
                        errorShowMsg={task.externalErrorMsg}
                        startAt={task.executeAt}
                        endAt={task.executeDoneAt}
                      />
                    ))}
                  </ul>
                </React.Fragment>
              )}
              {status === 'inProgress' && (
                <React.Fragment>
                  <ul className={styles.list}>
                    {tasks.map(task => (
                      <JobInprogress
                        key={task.id}
                        statusText={statusText}
                        jobInfo={`${t('features.EmployeeAttendances.components.CustomApiSyncJobsStatus.From_Custom_API')}`}
                        startAt={task.executeAt}
                      />
                    ))}
                  </ul>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      {isEmpty(tasks) && null}
    </React.Fragment>
  );
};

class CustomApiSyncJobsStatus extends React.Component {
  componentDidMount() {
    this.pollFetchVisibleCustomApiSyncJobs();
  }

  // TODO: このポーリングは無条件にステータス確認をしてしまいサーバーに余分な負荷を与えている
  // 処理中のみステータス確認のポーリングを行うのが理想
  // 取得ボタンのonclickでポーリングを開始するなどの修正を行うのが良い
  pollFetchVisibleCustomApiSyncJobs = () => {
    this.props.fetchVisibleCustomApiSyncJobs();
    setTimeout(this.pollFetchVisibleCustomApiSyncJobs, 60000);
  };

  render() {
    const { customApiSyncJobs = {}, hideSyncJobNotifications } = this.props;
    return (
      <React.Fragment>
        {isEmpty(customApiSyncJobs) ? null : (
          <div>
            {Object.keys(customApiSyncJobs).map(status => (
              <TaskResult
                key={status}
                tasks={customApiSyncJobs[status]}
                status={status}
                hideSyncJobNotifications={hideSyncJobNotifications}
              />
            ))}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    customApiSyncJobs: getCustomApiSyncJobs(state)
  }),
  dispatch => ({
    hideSyncJobNotifications: jobs => {
      const jobIds = jobs.map(j => j.id).join('_');
      if (jobIds.length > 0) {
        dispatch(setCustomApiSyncJobInvisible(jobIds));
      }
    },
    fetchVisibleCustomApiSyncJobs: () => dispatch(fetchCustomApiSyncJobStatus(true))
  })
)(CustomApiSyncJobsStatus);
